import { Column } from './Column';

export default Column;
export type { ColumnProps } from './types';
